<template>
	<span :aria-hidden="!title"
		:aria-label="title"
		class="material-design-icon cospend-icon"
		role="img"
		v-bind="$attrs"
		@click="$emit('click', $event)">
		<svg
			:fill="fillColor"
			:width="size"
			:height="size"
			enable-background="new 0 0 947.383 947.383"
			version="1.1"
			viewBox="0 0 947.38 947.38"
			xml:space="preserve"
			xmlns="http://www.w3.org/2000/svg">
			<path d="m566.83 2.896-93.137 49.266-93.454-49.434c-17.958-9.499-38.475 7.352-32.646 26.814l50.675 169.2c24.891-7.776 50.084-11.69 75.425-11.69 24.992 0 49.839 3.814 74.396 11.378l51.356-168.62c5.936-19.482-14.611-36.438-32.615-26.915z" />
			<path d="m782.74 722.66c0-230.95-79.884-515.21-310.83-515.21s-314.29 292.35-314.29 523.29c0 230.94 85.655 208.11 316.6 208.11 230.95 3e-3 308.52 14.762 308.52-216.18zm-275.1 50.106v41.03c0 13.261-10.751 24.011-24.012 24.011h-20.699c-13.262 0-24.012-10.75-24.012-24.011v-37.351c-28.598-3.5132-62.94-13.998-91.284-32.799-10.341-6.8598-13.319-21.063-6.6458-31.526l21.365-33.491c6.7448-10.57 20.756-13.856 31.409-7.2392 24.561 15.26 45.289 21.612 66.018 21.612 30.68 0 42.952-10.433 42.952-34.361 0-49.091-158.31-55.838-158.31-163.21 0-61.974 34.974-104.92 94.492-117.81v-40.814c0-12.702 10.297-23 23-23h22.722c12.703 0 23 10.297 23 23v39.586c30.098 4.7771 54.617 17.739 75.583 35.408 9.852 8.303 11.098 23.018 2.6576 32.751l-23.163 26.702c-7.7384 8.924-21.012 10.711-30.677 3.9261-15.733-11.045-30.691-16.567-47.716-16.567-26.383 0-39.269 7.3623-39.269 31.906 0 46.634 158.31 49.089 158.31 160.76-1e-3 59.521-31.295 106.15-95.72 121.49z" stroke-width="1.15" />
		</svg>
	</span>
</template>

<script>
export default {
	name: 'CospendIcon',
	props: {
		title: {
			type: String,
			default: '',
		},
		fillColor: {
			type: String,
			default: 'currentColor',
		},
		size: {
			type: Number,
			default: 24,
		},
	},
}
</script>
